import React from "react";
import { withAuth } from "shared/context/Auth";
import config from "../../config";
import Link from "../Link";

const UserMenu = ({ auth }) => {
  if (auth.isUserSignedIn) {
    const { user } = auth;
    const userMenu = config.getUserMobileMenu(user);

    return (
      <ul>
        {userMenu.items.map((item) => (
          <li key={item.url}>
            <Link href={item.url}>{item.title}</Link>
          </li>
        ))}
      </ul>
    );
  }

  const signInItem = config.getSignInItem();

  return (
    <ul>
      <li>
        <Link href={signInItem.url}>{signInItem.title}</Link>
      </li>
    </ul>
  );
};

export default withAuth(UserMenu);
